export default "__VITE_ASSET__zL$lrBEa__"